/**
 * Centralized auth service fetch helper.
 * Automatically appends `app=nucleus` to all requests so the auth service
 * knows which per-app feature flags to evaluate.
 */

const AUTH_SERVICE_URL = import.meta.env.VITE_AUTH_SERVICE_URL;
const APP_ID = 'nucleus';

if (!AUTH_SERVICE_URL) {
  console.warn('VITE_AUTH_SERVICE_URL is not defined');
}

/**
 * Builds a URL to the auth service with the app parameter automatically included.
 */
export function authServiceUrl(path: string): URL {
  const url = new URL(path, AUTH_SERVICE_URL);
  url.searchParams.set('app', APP_ID);
  return url;
}

/**
 * Fetch wrapper for auth service calls. Adds the `app` parameter to identify
 * the calling application so the auth service can route to the correct
 * identity provider (B2C vs External ID) based on per-app feature flags.
 */
export function authFetch(path: string, init?: RequestInit): Promise<Response> {
  return fetch(authServiceUrl(path), init);
}
